export default "__VITE_ASSET__jS_lHGPv__"